module.exports = __webpack_public_path__ + "static/img/rebar-gun_256.32df075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rebar-gun_256.png
// module id = 3GVy
// module chunks = 0